export enum CountryApi {
    GET_COUNTRY = "/country",
  }
  